export default class Notification {
   constructor(data) {
      this.signature = data.signature;
      this.metadata = data.metadata;
      this.read = data.read;
   }

   // Only marks property as read; does not update Redux
   setRead = (read = true) => {
      this.read = read;
   };
}
